import React, { useState, useRef } from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Toast } from "primereact/toast";
import { facultiesApi } from "../../../services/nomenclatures/facultiesApi";
import { paymentsApi } from "../../../services/payments/paymentsApi";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { format } from "date-fns";

const SemesterFeePaymentsReport: React.FC = () => {
  const toast = useRef<Toast>(null);
  const [facultyId, setFacultyId] = useState<number | undefined>();
  const [startDate, setStartDate] = useState<Date | undefined>();
  const [endDate, setEndDate] = useState<Date | undefined>();

  const { data: faculties } = facultiesApi.useGetFacultiesQuery();
  const [getSemesterFeePaymentsReport, { isLoading }] = paymentsApi.useGetSemesterFeePaymentsReportMutation();

  const handleExport = async () => {
    try {
      const body: { facultyId?: number; startDate?: string; endDate?: string } = {};

      if (facultyId) {
        body.facultyId = facultyId;
      }
      if (startDate) {
        body.startDate = format(startDate, "yyyy-MM-dd");
      }
      if (endDate) {
        body.endDate = format(endDate, "yyyy-MM-dd");
      }

      const blob = await getSemesterFeePaymentsReport(body).unwrap();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `semester-fee-payments-${format(new Date(), "yyyy-MM-dd")}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.current?.show({ severity: "success", summary: "Успех", detail: "Файлът е изтеглен успешно" });
    } catch (error) {
      toast.current?.show({ severity: "error", summary: "Грешка", detail: "Грешка при изтегляне на файла" });
      console.error("Export error:", error);
    }
  };

  const handleClearFilters = () => {
    setFacultyId(undefined);
    setStartDate(undefined);
    setEndDate(undefined);
  };

  return (
    <div className="flex justify-content-center flex-wrap">
      <Toast ref={toast} />
      <Card className="w-full mt-4">
        <div className="flex justify-content-between align-items-center">
          <h4>Справка за семестриални такси и плащания</h4>
          <div className="flex gap-2">
            <Button
              icon="pi pi-filter-slash"
              label="Изчисти филтри"
              className="p-button-secondary"
              onClick={handleClearFilters}
              disabled={!facultyId && !startDate && !endDate}
            />
            <Button
              icon="pi pi-file-excel"
              label="Изтегли Excel"
              className="p-button-success"
              onClick={handleExport}
              loading={isLoading}
            />
          </div>
        </div>
        <Divider />
        <div className="p-fluid formgrid grid">
          <div className="field col-12 md:col-4">
            <label htmlFor="facultyId">Факултет</label>
            <Dropdown
              id="facultyId"
              options={faculties?.data ?? []}
              optionLabel="name"
              optionValue="facultyId"
              placeholder="Всички факултети"
              value={facultyId}
              onChange={(e: DropdownChangeEvent) => setFacultyId(e.value)}
              showClear
              className="w-full"
            />
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="startDate">Начална дата</label>
            <Calendar
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.value as Date)}
              dateFormat="dd.mm.yy"
              placeholder="Изберете начална дата"
              showIcon
              showButtonBar
              className="w-full"
            />
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="endDate">Крайна дата</label>
            <Calendar
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.value as Date)}
              dateFormat="dd.mm.yy"
              placeholder="Изберете крайна дата"
              showIcon
              showButtonBar
              className="w-full"
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SemesterFeePaymentsReport;
